import { ClientsOverviewPage } from '@/pages/Clients';
import { ClientsPage } from '@/pages/Clients/ClientsPage';
import { Dashboard } from '@/pages/Dashboard';
import { LoginPage, NewPasswordPage, ResetPasswordPage } from '@/pages/Login/Login';
import { ORYXGOClientsOverviewPage } from '@/pages/ORYXGOMeasurement/ORYXGOClientOverview';
import { PitchingDashboard } from '@/pages/PitchingAnalysis';
import { ReportsPage } from '@/pages/ReportList';
import { RunReportDetailPageV2 } from '@/pages/ReportV2/RunReportV2';
import { SingleLegSquatReportDetailPageV2 } from '@/pages/ReportV2/SingleLegSquatsReportV2';
import { SquatReportDetailPageV2 } from '@/pages/ReportV2/SquatsReportV2';
import { WalkReportDetailPage } from '@/pages/ReportV2/WalkReportV2';
import { SensorTestingPage } from '@/pages/SensorTesting';
import { UploadPage } from '@/pages/Upload/Upload';
/** Main url routes for the application */
import { IonRouterOutlet, IonSplitPane } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router';

import ErrorBoundary from '@/components/ErrorBoundary/ErrorBoundary';
import { Sidebar } from '@/components/Sidebar/Sidebar';

import { ClientProvider, SessionProvider } from '@/contexts';
import { useAuthContext } from '@/contexts/authContext';
import { GuardedRoute } from '@/contexts/authContext/GuardedRoute';
import { GuestRoute } from '@/contexts/authContext/GuestRoute';
import { ReportProvider } from '@/contexts/reportContext';
import { UserInfoProvider } from '@/contexts/userInfoContext';

// import { SensorSidebar } from './components/SensorSidebar/SensorSidebar';

/** Main url routes for the application
 * FirebaseAuthConsumer provides the userId parameter to the sub pages when a user is logged in.
 * If you are not logged in only the home and login page is rendered.
 */
export const Routes = () => {
  const { isAuthorized } = useAuthContext();
  return (
    <IonReactRouter>
      {!isAuthorized() ? (
        <IonRouterOutlet>
          <GuestRoute path='/'>
            <LoginPage />
          </GuestRoute>
          <GuestRoute path='/login'>
            <LoginPage />
          </GuestRoute>
          <GuestRoute path='/resetPassword'>
            <ResetPasswordPage />
          </GuestRoute>
          <GuestRoute path='/newPassword'>
            <NewPasswordPage />
          </GuestRoute>
        </IonRouterOutlet>
      ) : (
        <IonSplitPane contentId='main' when='xs'>
          <UserInfoProvider>
            <ClientProvider>
              <SessionProvider>
                <Sidebar />
                {/* <SensorSidebar /> */}

                <IonRouterOutlet id='main'>
                  <ReportProvider>
                    <ErrorBoundary>
                      <GuardedRoute path='/'>
                        <Redirect to='/dashboard' />
                      </GuardedRoute>
                      <GuardedRoute path='/dashboard'>
                        <Dashboard />
                      </GuardedRoute>
                      {/* <GuardedRoute path='/admin'>
                        <AdminPage />
                      </GuardedRoute> */}

                      {/* Pitching analysis */}
                      <GuardedRoute path='/pitching'>
                        <PitchingDashboard />
                      </GuardedRoute>

                      {/* ORYX GO Analysis */}
                      <GuardedRoute path='/oryxgo'>
                        <ORYXGOClientsOverviewPage />
                      </GuardedRoute>
                      <GuardedRoute path='/oryxgo/:id'>
                        <ClientsPage />
                      </GuardedRoute>

                      <GuardedRoute path='/sensortesting'>
                        <SensorTestingPage />
                      </GuardedRoute>

                      {/* Clients */}
                      <GuardedRoute path='/clients'>
                        <ClientsOverviewPage />
                      </GuardedRoute>
                      <GuardedRoute path='/clients/:id'>
                        <ClientsPage />
                      </GuardedRoute>

                      <GuardedRoute path='/reports'>
                        <ReportsPage />
                      </GuardedRoute>

                      {/* Reports  */}
                      <GuardedRoute path='/reportsV2/Walk/:id'>
                        <WalkReportDetailPage />
                      </GuardedRoute>
                      <GuardedRoute path='/reportsV2/Run/:id'>
                        <RunReportDetailPageV2 />
                      </GuardedRoute>
                      <GuardedRoute path='/reportsV2/Squat/:id'>
                        <SquatReportDetailPageV2 />
                      </GuardedRoute>
                      <GuardedRoute path='/reportsV2/SingleLegSquat/:id'>
                        <SingleLegSquatReportDetailPageV2 />
                      </GuardedRoute>
                      <GuardedRoute path='/upload'>
                        <UploadPage />
                      </GuardedRoute>

                      {/* <GuardedRoute path='/docs'>
                        <KBHomePage />
                      </GuardedRoute>
                      <GuardedRoute path='/docs/ORYX_Measurements/Walk'>
                        <WalkMeasurementDoc />
                      </GuardedRoute> */}
                      <Route render={() => <Redirect to={'./dashboard'} />} />
                    </ErrorBoundary>
                  </ReportProvider>
                </IonRouterOutlet>
              </SessionProvider>
            </ClientProvider>
          </UserInfoProvider>
        </IonSplitPane>
      )}
    </IonReactRouter>
  );
};
